import { render, staticRenderFns } from "./popup-customer-follow-up-add.vue?vue&type=template&id=14331488&scoped=true"
import script from "./popup-customer-follow-up-add.vue?vue&type=script&lang=js"
export * from "./popup-customer-follow-up-add.vue?vue&type=script&lang=js"
import style0 from "./popup-customer-follow-up-add.vue?vue&type=style&index=0&id=14331488&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14331488",
  null
  
)

export default component.exports